import EventOverviewPageActionTypes from './event-overview-page-action-types';
import axios from 'axios';
import ValidationError from '../../../utils/validation-error';
import { ROLE_PERMISSIONS as Permissions } from '../../../resources/rolePermissions';

export const loadEventOverviewPage = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: EventOverviewPageActionTypes.LOAD_EVENT_OVERVIEW_PAGE_START });
  const state = getState().generalCompetencyEventOverviewPage;
  try {
    state.cancelToken?.cancel();
    state.cancelToken = axios.CancelToken.source();
    const event = await api.get(`api/general_competency_events/${payload.eventId}`, null, state.cancelToken.token);
    const canWrite = getState().app.userPermissions.includes(Permissions.GENERAL_COMPETENCY_EVENTS_WRITE);
    dispatch({
      type: EventOverviewPageActionTypes.LOAD_EVENT_OVERVIEW_PAGE_END,
      payload: {
        event,
        canWrite
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: EventOverviewPageActionTypes.LOAD_EVENT_OVERVIEW_PAGE_END });
      throw error;
    }
  }
};

export const changeEventStatus = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: EventOverviewPageActionTypes.CHANGE_EVENT_STATUS_START });
  try {
    await api.put(`api/general_competency_events/${payload.eventId}/change_status`, { status: payload.status });
    dispatch(loadEventOverviewPage({ eventId: payload.eventId }));
  } catch (error) {
    dispatch({ type: EventOverviewPageActionTypes.CHANGE_EVENT_STATUS_END });
    throw error;
  }
};

export const openEventOverviewConfirmDialog = () => async(dispatch) => {
  dispatch({ type: EventOverviewPageActionTypes.TOGGLE_EVENT_OVERVIEW_CONFIRM_DIALOG, payload: { isVisible: true } });
};

export const closeEventOverviewConfirmDialog = () => async(dispatch) => {
  dispatch({ type: EventOverviewPageActionTypes.TOGGLE_EVENT_OVERVIEW_CONFIRM_DIALOG, payload: { isVisible: false } });
};

export const removeEventOverviewConfirmDialog = (payload) => async(dispatch, getState, { api }) => {
  try {
    await api.remove(`api/general_competency_events/${payload.eventId}`);
    dispatch({ type: EventOverviewPageActionTypes.TOGGLE_EVENT_OVERVIEW_CONFIRM_DIALOG, payload: { isVisible: false } });
    payload.navigate('/general_competency_events');
  } catch (error) {
    if (error instanceof ValidationError) {
      dispatch({ type: EventOverviewPageActionTypes.TOGGLE_EVENT_OVERVIEW_CONFIRM_DIALOG, payload: { isVisible: true, errorMessage: error.message } });
    } else {
      throw error;
    }
  }
};

export const selectEventOverviewPageTab = (payload) => async(dispatch) => {
  dispatch({
    type: EventOverviewPageActionTypes.SELECT_EVENT_OVERVIEW_PAGE_TAB,
    payload: {
      selected: payload.selected
    }
  });
};
